export const Bold = ({ children, className, size, style = {}, color = '' }) => (
  <p className={`fw-bold m-0 ${className}`} style={{ fontSize: size, ...style, color }}>
    {children}
  </p>
);
